import { faInternetExplorer } from '@fortawesome/free-brands-svg-icons/faInternetExplorer';

export default [
  faInternetExplorer,
];
